module.exports = __webpack_public_path__ + "static/media/CC_NG_LP_animation_RO.67bf6e69.gif";